module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Hc-Ia.58842b93.png";